import { Editor } from '@/lib/components/Shared/editor/TextEditor.types';
import { EventEmitters } from '@/domain/utils/Events';

enum EditorEvents {
	Blur = 'blur',
	Focus = 'focus',
	Input = 'input',
	Keyup = 'keyup',
	Upload = 'upload',
}

type OnBlur = (event: EditorEvents.Blur) => void;
type OnFocus = (event: EditorEvents.Focus, element: HTMLElement | Editor) => void;
type OnInput = (event: EditorEvents.Input, html: string) => void;
type OnKeyUp = (event: EditorEvents.Keyup, element: HTMLElement) => void;
type OnUpload = (event: EditorEvents.Upload) => void;

type EditorEmit = OnBlur & OnFocus & OnInput & OnKeyUp & OnUpload;

type EditorEmitters = EventEmitters<{
	[EditorEvents.Blur]: () => void;
	[EditorEvents.Focus]: (element: HTMLElement | Editor) => void;
	[EditorEvents.Input]: (html: string) => void;
	[EditorEvents.Keyup]: (element: HTMLElement) => void;
	[EditorEvents.Upload]: () => void;
}>;

export { EditorEmit, EditorEmitters, EditorEvents };
